import { ApiUrl } from "../components/Common/ApiUrl";
import httpServiceInstance from "../helper/HttpService";

export const platformStatsService = async (data) => {
  const response = await httpServiceInstance.get(
    `${ApiUrl.PLATFORM_STATS}`
  );
  return response;
};
